import { createRouter,createWebHistory } from "vue-router";
import Index from '../views/Index.vue';
import Login from '../views/Login.vue'
const router = createRouter({
    history:createWebHistory(),
    routes:[
        {
            path:'/',
            name: 'index',
            component: Index
        }
    ]
})

export default router;